import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import SVGIcon from '../../../components/SVGIcon';
import addIcon from '../../../icons/non-prefilled/16x16/add.svg';
import * as styles from './RowColumnInsertButton.module.scss';
import OpacityMotionTransition from '../../../components/OpacityMotionTransition';

interface RowColumnInsertButtonProps {
  first?: boolean;
  direction: 'row' | 'column';
  rearranging: boolean;
  onInsert: () => void;
}

const RowColumnInsertButton = ({
  first = false,
  direction,
  rearranging,
  onInsert,
}: RowColumnInsertButtonProps) => {
  const ref = useRef<HTMLButtonElement | null>(null);
  const [indicatorSizeStyle, setIndicatorSizeStyle] = useState<{
    width?: number;
    height?: number;
  } | null>(null);

  return (
    <>
      <button
        aria-label={`Insert ${direction}`}
        ref={ref}
        data-no-print
        type="button"
        className={classNames(styles.button, styles[direction], {
          [styles.first]: first,
        })}
        onClick={() => onInsert()}
        onMouseEnter={() => {
          const table = ref.current?.closest('table');
          if (table) {
            const tableRect = table.getBoundingClientRect();
            setIndicatorSizeStyle(
              direction === 'row'
                ? { width: tableRect.width }
                : { height: tableRect.height },
            );
          }
        }}
        onMouseLeave={() => setIndicatorSizeStyle(null)}
      />
      <AnimatePresence>
        {indicatorSizeStyle && !rearranging && (
          <OpacityMotionTransition
            className={classNames(styles.indicator, styles[direction], {
              [styles.first]: first,
            })}
          >
            <SVGIcon className={styles.icon} size={11}>
              {addIcon}
            </SVGIcon>
            <div className={styles.line} style={indicatorSizeStyle} />
          </OpacityMotionTransition>
        )}
      </AnimatePresence>
    </>
  );
};

export default RowColumnInsertButton;
